import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    product: { 
        name: '',
        code: '', 
        description: '', 
        image: '', 
    }, 
    products: [],
};

const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {
        setProduct: (state, action) => {
           state.product = {...action.payload};
        },
        setEditProduct: (state, action) => {
            state.product = {...action.payload};
        }, 
        setImage: (state, action) => {
            state.product.image = action.payload;
        },
        clearProduct: (state) => initialState,
        setProducts: (state, action) => {
            state.products = action.payload;
        }
    }
});

export const productActions = productSlice.actions;
export default productSlice.reducer;